import { checkResponse } from "./statics1";

export default class stat {
  static async getCounts(
    asiakasId = 0,
    tyomaaId = 0,
    pumppuAsiakasId = 0,
    betoniAsiakasId = 0,
    token
  ) {
    try {
      const url1 =
        import.meta.env.VITE_SERVER_URL +
        "/api/stat/getCount/" +
        asiakasId +
        "/" +
        tyomaaId +
        "/" +
        pumppuAsiakasId +
        "/" +
        betoniAsiakasId;
      const response = await fetch(url1, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "stat:getCounts");
      if (!cResponse.success) return false;
      const result = cResponse.data;
      return result;
    } catch (err) {
      console.log(err);
    }
  }
}
